/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import './style/loginView.scss';

import React, {FocusEventHandler, KeyboardEventHandler, MouseEventHandler, useContext} from 'react';
import classNames from 'classnames';
import {ChangeFunction, DvrdButton, DvrdInput, DvrdPasswordInput, ErrorType, Loader} from '@dvrd/dvr-controls'
import {AppContext} from "../../misc/appContext";
import {colorIsWhite, convertColor} from "../../../util/constants";

interface LoginProps {
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    onChangeEmail: ChangeFunction<string>;
    onChangePassword: ChangeFunction<string>;
    onResetError: FocusEventHandler;
    email: string;
    password: string;
    loading: boolean;
    error: ErrorType;
}

export default function LoginView(props: LoginProps) {
    const context = useContext(AppContext);
    const {onSubmit, loading, email, onChangeEmail, onChangePassword, password, error, onResetError} = props;

    function getBaseColor() {
        const {baseColor, contrastColor} = context.theme;
        let color = convertColor(baseColor);
        if (colorIsWhite(color)) color = convertColor(contrastColor);
        return color;
    }

    function renderHeader() {
        return (
            <div className='header-container'>
                <label className='header-title' style={{color: getBaseColor()}}>Inloggen</label>
            </div>
        )
    }

    function renderBody() {
        return (
            <div className='body-container'>
                <DvrdInput onChange={onChangeEmail} value={email} type='email' label='E-mailadres'
                           onFocus={onResetError} onEnter={onSubmit}/>
                <DvrdPasswordInput onChange={onChangePassword} value={password} label='Wachtwoord'
                                   onFocus={onResetError} onEnter={onSubmit} className='pass-field'/>
                <label className={classNames('error-label', error !== null && 'visible')}>{error}</label>
            </div>
        )
    }

    function renderFooter() {
        return (
            <div className='footer-container'>
                <DvrdButton label='Inloggen' onClick={onSubmit} disabled={loading}/>
            </div>
        );
    }

    return (
        <div className='login-view'>
            <Loader active={loading}/>
            {renderHeader()}
            {renderBody()}
            {renderFooter()}
        </div>
    );
}